module.exports = __webpack_public_path__ + "img/tf.d192dc79.svg";